/** Namespace `notes` (Behandlungsnotizen) — befüllt während der Migration. */
export const notes = {
  de: {
    notes: {
      // Kind labels
      kindVisit: 'Behandlung',
      kindNote: 'Notiz',

      // TreatmentNotesSection — header / list
      heading: 'Behandlungsverlauf ({{count}})',
      showArchived: 'Archivierte zeigen',
      withTemplate: 'Mit Vorlage',
      withTemplateTitle: 'Neue Notiz mit Vorlage',
      freetext: 'Freitext',
      loading: 'Lade…',
      empty: 'Noch keine Notizen.',
      archivedBadge: 'archiviert',
      templateBadgeFallback: 'Vorlage',
      templateEdited: 'edit',
      noAppointment: 'Termin',
      placeholderDash: '—',
      patientFallback: 'Patient #{{id}}',

      // Editor fields
      type: 'Typ',
      linkedAppointment: 'Verknüpfter Termin (optional)',
      noAppointmentOption: '— Kein Termin —',
      noteBody: 'Notiztext',
      noteBodyPlaceholder: 'Was wurde besprochen oder durchgeführt?',
      affectedTeeth: 'Betroffene Zähne (FDI)',
      selected: 'Ausgewählt: {{teeth}}',
      showStructured: 'Strukturierte Felder einblenden',
      hideStructured: 'Strukturierte Felder ausblenden',
      chiefComplaint: 'Hauptbeschwerde',
      findings: 'Befund',
      treatmentPerformed: 'Durchgeführte Behandlung',
      treatmentPerformedShort: 'Behandlung',
      plan: 'Plan / nächste Schritte',
      planShort: 'Plan',
      cancel: 'Abbrechen',
      save: 'Speichern',
      saving: 'Speichere…',

      // Row actions
      edit: 'Bearbeiten',
      archive: 'Archivieren',
      unarchive: 'Wiederherstellen',

      // Toasts
      errorLoad: 'Notizen konnten nicht geladen werden',
      templateLoadFallback: 'Vorlage konnte nicht geladen werden — fällt auf Freitext-Edit zurück.',
      audioUploadError: 'Audio-Upload fehlgeschlagen',
      noteUpdated: 'Notiz aktualisiert.',
      noteCreated: 'Notiz angelegt.',
      errorSave: 'Speichern fehlgeschlagen',
      bodyRequired: 'Bitte einen Notiztext eingeben.',
      noteSaved: 'Notiz gespeichert.',
      confirmArchive: 'Notiz vom {{date}} archivieren?',
      noteArchived: 'Notiz archiviert.',
      errorArchive: 'Archivieren fehlgeschlagen',
      noteUnarchived: 'Notiz wiederhergestellt.',
      errorUnarchive: 'Wiederherstellen fehlgeschlagen',

      // NewTreatmentNoteDialog
      dialogTitle: 'Neue Dokumentation',
      dialogPatient: 'Patient:',
      dialogPractitioner: 'Behandler:',
      close: 'Schließen',
      searchTemplatePlaceholder: 'Vorlage suchen ...',
      allCount: 'Alle ({{count}})',
      noTemplateFound: 'Keine Vorlage gefunden für „{{query}}".',
      sectionsCount: '{{count}} Sektionen · v{{version}}',
      aiAssist: 'KI-Assistenz (folgt)',
      aiAssistTitle: 'Phase B: Audio + Whisper folgt',
      withoutTemplate: 'Ohne Vorlage (Freitext)',

      // TreatmentNoteTemplateEditor
      editorBack: 'Abbrechen',
      editorTitleAria: 'Titel der Dokumentation',
      templateMeta: 'Vorlage: {{slug}} · v{{version}}',
      practitionerLabel: 'Behandler:',
      patientLabel: 'Patient:',
      languageAria: 'Sprache',
      noConsentReason: 'Patient hat keine Audio-Einwilligung erteilt',
      manualEdit: 'Manueller Edit',
      documentation: 'Dokumentation',
      manual: 'Manuell',
      autoGenerated: 'Auto-generiert',
      manualBodyPlaceholder: 'Manuell editierter Dokumentations-Text — überschreibt das Template-Rendering.',
      previewEmpty: 'Noch keine Sektion ausgefüllt — Doku-Vorschau erscheint hier, sobald du links Werte wählst.',
      audioTranscript: 'Audio & Transkript',
      recordingsCount: '{{count}} Aufnahme(n)',
      uploadingAudio: 'Lade Audio hoch ...',
      recording: 'Aufnahme',
      transcribing: 'Transkribiert ...',
      transcriptDone: 'Fertig',
      transcriptFailed: 'Fehler',
      transcriptSkipped: 'Übersprungen (kein STT-Key)',
      transcriptSkippedTitle: 'Kein API-Key konfiguriert',
      applyTranscript: 'In Doku übernehmen',
      noSections: 'Diese Vorlage hat keine Sektionen.',

      // TemplateSectionInputs
      reset: 'zurücksetzen',
      unknownSectionType: 'Unbekannter Section-Typ: {{type}}',

      // ProcedureSidebar
      procedureSuggestions: 'Procedure-Vorschläge',
      calculating: 'berechnet ...',
      suggestionCount_one: '{{count}} Vorschlag',
      suggestionCount_other: '{{count}} Vorschläge',
      suggestionsEmpty:
        'Vorschläge erscheinen, sobald Sektionen ausgefüllt sind oder Template-Default-Procedures hinterlegt sind.',
      sourceTemplate: 'Vorlage',
      suggestionsFooter: 'Beim Speichern können diese Procedures in eine Rechnung übernommen werden.',

      // ToothChart
      permanent: 'permanent',
      deciduous: 'Milchzähne',
      rowUpper: 'Ober',
      rowLower: 'Unter',
      tooth: 'Zahn {{code}}',

      // AudioRecorder
      browserNoAudio: 'Browser unterstützt keine Audio-Aufnahme.',
      recordingDisabled: 'Aufnahme deaktiviert',
      recordButton: 'Aufnahme',
      pause: 'Pause',
      stop: 'Stopp',
      paused: 'pausiert',
      resume: 'Fortsetzen',
      recordingReady: 'Aufnahme bereit ({{duration}})',
      discard: 'Verwerfen',
      micDenied: 'Mikrofon-Zugriff verweigert',

      // AudioConsentBadge
      consentLoading: 'Audio-Consent lädt …',
      consentGranted: 'Audio-Consent erteilt',
      consentGrantedAt: 'Erteilt: {{date}}',
      consentDenied: 'Audio verweigert',
      consentPristine: 'Audio-Consent nicht erfasst',
      consentGrant: 'Erteilen',
      consentRevoke: 'Entziehen',
      consentRecorded: 'Audio-Einwilligung erfasst.',
      consentWithdrawn: 'Audio-Einwilligung entzogen.',
      consentError: 'Fehler beim Speichern der Einwilligung',
    },
  },
  es: {
    notes: {
      kindVisit: 'Tratamiento',
      kindNote: 'Nota',

      heading: 'Historial de tratamiento ({{count}})',
      showArchived: 'Mostrar archivadas',
      withTemplate: 'Con plantilla',
      withTemplateTitle: 'Nueva nota con plantilla',
      freetext: 'Texto libre',
      loading: 'Cargando…',
      empty: 'Aún no hay notas.',
      archivedBadge: 'archivada',
      templateBadgeFallback: 'Plantilla',
      templateEdited: 'edit',
      noAppointment: 'Cita',
      placeholderDash: '—',
      patientFallback: 'Paciente n.º {{id}}',

      type: 'Tipo',
      linkedAppointment: 'Cita vinculada (opcional)',
      noAppointmentOption: '— Sin cita —',
      noteBody: 'Texto de la nota',
      noteBodyPlaceholder: '¿Qué se ha tratado o realizado?',
      affectedTeeth: 'Dientes afectados (FDI)',
      selected: 'Seleccionados: {{teeth}}',
      showStructured: 'Mostrar campos estructurados',
      hideStructured: 'Ocultar campos estructurados',
      chiefComplaint: 'Motivo de consulta',
      findings: 'Hallazgos',
      treatmentPerformed: 'Tratamiento realizado',
      treatmentPerformedShort: 'Tratamiento',
      plan: 'Plan / próximos pasos',
      planShort: 'Plan',
      cancel: 'Cancelar',
      save: 'Guardar',
      saving: 'Guardando…',

      edit: 'Editar',
      archive: 'Archivar',
      unarchive: 'Restaurar',

      errorLoad: 'No se pudieron cargar las notas',
      templateLoadFallback: 'No se pudo cargar la plantilla — se vuelve a la edición de texto libre.',
      audioUploadError: 'Error al subir el audio',
      noteUpdated: 'Nota actualizada.',
      noteCreated: 'Nota creada.',
      errorSave: 'Error al guardar',
      bodyRequired: 'Introduzca un texto para la nota.',
      noteSaved: 'Nota guardada.',
      confirmArchive: '¿Archivar la nota del {{date}}?',
      noteArchived: 'Nota archivada.',
      errorArchive: 'Error al archivar',
      noteUnarchived: 'Nota restaurada.',
      errorUnarchive: 'Error al restaurar',

      dialogTitle: 'Nueva documentación',
      dialogPatient: 'Paciente:',
      dialogPractitioner: 'Doctor:',
      close: 'Cerrar',
      searchTemplatePlaceholder: 'Buscar plantilla ...',
      allCount: 'Todas ({{count}})',
      noTemplateFound: 'No se encontró ninguna plantilla para «{{query}}».',
      sectionsCount: '{{count}} secciones · v{{version}}',
      aiAssist: 'Asistencia de IA (próximamente)',
      aiAssistTitle: 'Fase B: audio + Whisper próximamente',
      withoutTemplate: 'Sin plantilla (texto libre)',

      editorBack: 'Cancelar',
      editorTitleAria: 'Título de la documentación',
      templateMeta: 'Plantilla: {{slug}} · v{{version}}',
      practitionerLabel: 'Doctor:',
      patientLabel: 'Paciente:',
      languageAria: 'Idioma',
      noConsentReason: 'El paciente no ha otorgado el consentimiento de audio',
      manualEdit: 'Edición manual',
      documentation: 'Documentación',
      manual: 'Manual',
      autoGenerated: 'Generado automáticamente',
      manualBodyPlaceholder: 'Texto de documentación editado manualmente — sustituye el renderizado de la plantilla.',
      previewEmpty: 'Aún no hay ninguna sección rellena — la vista previa aparecerá aquí en cuanto elija valores a la izquierda.',
      audioTranscript: 'Audio y transcripción',
      recordingsCount: '{{count}} grabación(es)',
      uploadingAudio: 'Subiendo audio ...',
      recording: 'Grabación',
      transcribing: 'Transcribiendo ...',
      transcriptDone: 'Listo',
      transcriptFailed: 'Error',
      transcriptSkipped: 'Omitido (sin clave STT)',
      transcriptSkippedTitle: 'No hay clave API configurada',
      applyTranscript: 'Añadir a la documentación',
      noSections: 'Esta plantilla no tiene secciones.',

      reset: 'restablecer',
      unknownSectionType: 'Tipo de sección desconocido: {{type}}',

      procedureSuggestions: 'Sugerencias de tratamiento',
      calculating: 'calculando ...',
      suggestionCount_one: '{{count}} sugerencia',
      suggestionCount_other: '{{count}} sugerencias',
      suggestionsEmpty:
        'Las sugerencias aparecen en cuanto se rellenan secciones o hay tratamientos predeterminados de la plantilla.',
      sourceTemplate: 'Plantilla',
      suggestionsFooter: 'Al guardar, estos tratamientos se pueden incluir en una factura.',

      permanent: 'permanente',
      deciduous: 'Dientes de leche',
      rowUpper: 'Superior',
      rowLower: 'Inferior',
      tooth: 'Diente {{code}}',

      browserNoAudio: 'El navegador no admite la grabación de audio.',
      recordingDisabled: 'Grabación desactivada',
      recordButton: 'Grabar',
      pause: 'Pausa',
      stop: 'Detener',
      paused: 'en pausa',
      resume: 'Reanudar',
      recordingReady: 'Grabación lista ({{duration}})',
      discard: 'Descartar',
      micDenied: 'Acceso al micrófono denegado',

      consentLoading: 'Cargando consentimiento de audio …',
      consentGranted: 'Consentimiento de audio otorgado',
      consentGrantedAt: 'Otorgado: {{date}}',
      consentDenied: 'Audio denegado',
      consentPristine: 'Consentimiento de audio no registrado',
      consentGrant: 'Otorgar',
      consentRevoke: 'Retirar',
      consentRecorded: 'Consentimiento de audio registrado.',
      consentWithdrawn: 'Consentimiento de audio retirado.',
      consentError: 'Error al guardar el consentimiento',
    },
  },
};
